import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { decoratedFetch } from "../req_utils";
import { updateEmployeeBranchId } from "../reducers";
import {
  DARK_THEME_TEXT_COLOR,
  LIGHT_THEME_TEXT_COLOR,
} from "../constants";

const BranchSelector = () => {
  const dispatch = useDispatch();
  const employee = useSelector((state) => state.employee);
  const employee_branch_id = useSelector((state) => state.employee_branch_id);
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  const isAdministrator = employee?.employee_type === "Administrator";

  useEffect(() => {
    // Fetch all branches
    decoratedFetch("/list_branch_addresses")
      .then((response) => {
        if (!response?.ok) {
          throw new Error(
            `Unable to load branches (HTTP ${response?.status ?? "unknown"})`,
          );
        }
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) {
          throw new Error("Invalid branches response: expected an array");
        }
        setBranches(data);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
        setBranches([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleBranchChange = (event) => {
    const newBranchId = event.target.value;
    dispatch(updateEmployeeBranchId(newBranchId));
  };

  if (loading || !branches.length || !employee_branch_id || !isAdministrator) {
    return null;
  }

  return (
    <Box sx={{ mr: "20px", minWidth: "120px" }}>
      <FormControl fullWidth size="small">
        <Select
          value={employee_branch_id || ""}
          onChange={handleBranchChange}
          disabled={!isAdministrator}
          sx={{
            color: "white",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255, 255, 255, 0.3)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255, 255, 255, 0.5)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
            "& .MuiSelect-icon": {
              color: "white",
            },
            "&.Mui-disabled": {
              color: "rgba(255, 255, 255, 0.5)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(255, 255, 255, 0.2)",
              },
              "& .MuiSelect-icon": {
                color: "rgba(255, 255, 255, 0.3)",
              },
            },
          }}
        >
          {branches?.map((branch) => (
            <MenuItem key={branch?.id} value={branch?.id}>
              {branch?.name || branch?.state}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default BranchSelector;

